import React from "react";
import "./styles.scss";
import { Modal, Backdrop } from "@mui/material";
import { Clear } from "@mui/icons-material";

import { useStateValue } from "../../store";
import EmailSection from "../score/emailSection";

const EmailPopup = (props) => {
  const [{ emailPopup }, dispatch] = useStateValue();

  const [open, setOpen] = React.useState(true);

  const handleClose = (event, reason) => {
    if (reason && reason === "backdropClick") return;
    else {
      setOpen(false);
      dispatch({
        type: "SET_EMAIL_POPUP",
        value: false,
        data: {},
      });
    }
  };
  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      closeAfterTransition
      onClose={handleClose}
      disableAutoFocus={true}
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      className="email-popup-container"
    >
      <div className="popup-container">
        <div className="title">
          <p>Enter your email address</p>
          <Clear className="clear-btn" onClick={() => handleClose()} />
        </div>

        <div className="add-message">
          Please enter your email address to proceed further.
        </div>
        <div className="email-section">
          <EmailSection />
        </div>
      </div>
    </Modal>
  );
};

export default EmailPopup;
